import { render, staticRenderFns } from "./cpFlow.vue?vue&type=template&id=2c7dd75c&scoped=true&"
import script from "./cpFlow.vue?vue&type=script&lang=js&"
export * from "./cpFlow.vue?vue&type=script&lang=js&"
import style0 from "./cpFlow.vue?vue&type=style&index=0&id=2c7dd75c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7dd75c",
  null
  
)

export default component.exports